export const BRAND = {
  // NEW transparent logo (LOGO MAIN 004 — cream "TATI" + pink "SOFIA" + orange icon + subtitle + heart) — processed locally to drop black background
  logoMain: "/logo-tatisisofia.png",
  logoLight: "/logo-tatisisofia.png",
  // CLEAN cinematic imagery (no text overlay) — safe for hero/article cards
  heroDreams: "https://customer-assets.emergentagent.com/job_narcisism-ro/artifacts/43t1yvx6_IMG%20TS%20003.png", // father+daughter cosmos dreams
  imgSunsetVillage: "https://customer-assets.emergentagent.com/job_narcisism-ro/artifacts/dcvqnro7_IMG%20TS%20003A.png", // father+daughter sunset village
  imgChurchPath: "https://customer-assets.emergentagent.com/job_narcisism-ro/artifacts/d1wuj70z_IMG%20TS%20003B.png", // father+daughter church path
  // FUTURE / vision imagery (has Romanian text overlay — used in dedicated vision section only)
  imgFuture: "https://customer-assets.emergentagent.com/job_narcisism-ro/artifacts/9balk7nt_IMG%20TS%20004%20FUTURE.png",
  imgLawAdopted: "https://customer-assets.emergentagent.com/job_narcisism-ro/artifacts/xl2xupg8_IMG%20TS%20005%20VOT.png",
  // EDUCATIONAL INFOGRAPHICS
  infoCiclulAlienarii: "https://customer-assets.emergentagent.com/job_narcisism-ro/artifacts/n03gin5q_alienare%201.png",
  info13Tactici: "https://customer-assets.emergentagent.com/job_narcisism-ro/artifacts/j86pxeic_alienare%202.png",
  // Generic alias used across pages
  banner: "https://customer-assets.emergentagent.com/job_narcisism-ro/artifacts/43t1yvx6_IMG%20TS%20003.png",
  bannerHero: "https://customer-assets.emergentagent.com/job_narcisism-ro/artifacts/43t1yvx6_IMG%20TS%20003.png",
  // Legacy fallback
  logoDark: "/logo-tatisisofia.png",
};

// Founder portrait — use clean sunset image (NOT banner with text)
export const GABRIEL_AVATAR = "https://customer-assets.emergentagent.com/job_narcisism-ro/artifacts/dcvqnro7_IMG%20TS%20003A.png";

// Watermark text shown bottom-right on every <BrandedImage>
export const SITE_WATERMARK = "tatisisofia.ro";

export const CATEGORIES = [
  { value: "alienare", label: "Alienare Parentală" },
  { value: "relatii", label: "Relații" },
  { value: "narcisism", label: "Narcisism" },
  { value: "trauma", label: "Traumă Copil" },
  { value: "sistem", label: "Sistem & Justiție" },
  { value: "vindecare", label: "Vindecare" },
];

export const COUNTIES = [
  "Alba","Arad","Argeș","Bacău","Bihor","Bistrița-Năsăud","Botoșani","Brașov","Brăila","București",
  "Buzău","Caraș-Severin","Călărași","Cluj","Constanța","Covasna","Dâmbovița","Dolj","Galați","Giurgiu",
  "Gorj","Harghita","Hunedoara","Ialomița","Iași","Ilfov","Maramureș","Mehedinți","Mureș","Neamț",
  "Olt","Prahova","Sălaj","Satu Mare","Sibiu","Suceava","Teleorman","Timiș","Tulcea","Vaslui","Vâlcea","Vrancea"
];

export const WHATSAPP_NUMBER = "40751123777";
export const waLink = (msg = "Salut, am o întrebare prin TatiSiSofia.ro") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
